import {
  CategoriesActions,
  CategoriesActionsEnum,
  ICategoriesReducer,
} from 'store/reducers/categoriesReducer/categoriesTypes';
import { ECommonActions } from 'store/reducers/types';

const initialState: ICategoriesReducer = {
  isLoading: true,
  isUpdated: false,
  results: [],
};

export default function(state = initialState, action: CategoriesActions): ICategoriesReducer {
  switch (action.type) {
    case CategoriesActionsEnum.GetCategories: {
      return { ...state, ...action.payload };
    }

    case ECommonActions.CleanStore: {
      return initialState;
    }

    default:
      return state;
  }
}
